<lex-doc-viewer-dialog class="fontify-13px fontify-color-2"> 
  <div dialog-title>{{strategy.title}}</div>
  <div dialog-body>
    <div style="padding:8px 16px; display:flex; flex-direction: column; gap: 24px;">
      <div *ngIf="alert" class="alert">
        <div>{{alert}}</div>
      </div>
      <div>{{strategy.message}}</div>
      <div class="custom-file-input">
        <input type="file" id="fileInput" [disabled]="!canUpload" (change)="fileSelected($event.target.files)">
        <label for="fileInput">Choose a file</label>
        <span *ngIf="selectedFileName.length < 1" style="opacity: 0.5;">No file chosen</span>
        <span *ngIf="selectedFileName.length > 0">{{ selectedFileName }}</span>
      </div>
    </div>
  </div>
  <div dialog-actions>
    <div style="display:flex; flex-direction: row; justify-content: flex-end; padding: 12px; gap: 4px;">
      <lex-flat-button label="Upload" [type]="'action'" (click)="ok()" [disabled]="!selectedFile || !canUpload"></lex-flat-button>
      <lex-flat-button label="Cancel" [type]="'action'" matDialogClose></lex-flat-button>
    </div>
  </div>
</lex-doc-viewer-dialog>
